import type { ReactElement } from 'react';
import { MDText } from 'i18n-react';

import localTexts from './HighestOffer.texts.json';

import styles from './HighestOffer.module.scss';

const LocalT = new MDText(localTexts);

type HighestOfferProps = {
	offer: string;
};

export const HighestOffer = ({ offer }: HighestOfferProps): ReactElement => {
	return (
		<div className={styles.highestOfferContainer}>
			<span>{LocalT.translate('highestOffer')}</span>
			<span className={styles.offer}>{offer}</span>
		</div>
	);
};
